<template>
  <div>
    <v-row>
      <v-col class="font-weight-bold">
        Order Amount
      </v-col>
      <v-col class="font-weight-bold">
        ${{ orderData.totalAmount }}
      </v-col>
    </v-row>
    <v-row
      v-for="paymentMethod in paymentMethods"
      :key="paymentMethod.id"
      align="center"
    >
      <v-col class="font-weight-bold">
        {{ paymentMethod.description }}
      </v-col>
      <v-col>
        <v-text-field
          v-model="inputAmount[paymentMethod.id]"
          prefix="$"
          hide-details="auto"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="font-weight-bold">
        Allocated Amount
      </v-col>
      <v-col class="font-weight-bold">
        ${{ allocatedAmount }}
      </v-col>
    </v-row>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/store'

const store = useStore()
console.log('store', store)

const orderData = computed(() => ({ ...store.getters.orderInfo }))

const inputAmount = ref({})

defineExpose({
  inputAmount,
})

const paymentMethods = ref([
  {
    id: 1,
    description: 'Cash',
  },
  {
    id: 2,
    description: 'Visa / Master',
  },
  {
    id: 3,
    description: 'Octpous',
  },
  {
    id: 4,
    description: 'PayMe',
  },
  {
    id: 5,
    description: 'WeChatPay',
  },
])

const allocatedAmount = computed(() => {
  let total = 0
  const inputAmountObj = inputAmount.value
  console.log('inputAmountObj', inputAmountObj)
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(inputAmountObj)) {
    const parseVal = parseInt(value, 10) || 0
    console.log('parseVal', parseVal)
    total += parseVal
  }

  console.log('total', total)

  return total
})
</script>
